<template>
  <LayoutDYADefault>
    <template #leftMenuIngang>
      <!-- <div>
        <v-list-subheader class="mt-5 !text-gray-300">{{ creatorNameKo }} 메뉴</v-list-subheader>
        <MiscDYGroupMenu v-for="(val, key) in leftMenuTeacher" v-bind="val" :key="key" />
      </div> -->
      <slot name="leftMenuIngang" />

      <!-- <v-list-subheader class="mt-5">사이트 회원 관리</v-list-subheader>
     <MiscDYGroupMenu v-for="(val,key) in leftMenu2" v-bind="val" :key="key"/>

     <v-list-subheader class="mt-5">결제 관리</v-list-subheader>
     <MiscDYGroupMenu v-for="(val,key) in leftMenuPayments" v-bind="val" :key="key"/>

     <v-list-item v-if="siteName === '도약닷컴'" rounded="lg" class="first-level-item mb-1">
       <v-list-item-title class="ml-8">저작권정산/출력</v-list-item-title>
     </v-list-item>

     <v-list-subheader class="mt-5">콘텐츠 관리</v-list-subheader>
     <MiscDYGroupMenu v-for="(val,key) in leftMenuContents" v-bind="val" :key="key"/> -->
      <!--		개별 컨텐츠 메뉴 설정은 각 사이트 impl에서 필요함. 정규강의, 투어, 곡별강의, 무료특강, 묶음상 메뉴		-->
    </template>
    <slot name="default" />
  </LayoutDYADefault>
</template>

<script setup lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBook,
  faCalendar,
  faCards,
  faChartArea,
  faChartLineUp,
  faClipboardCheck,
  faCog,
  faDownload,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileCertificate,
  faFileMusic,
  faFileWord,
  faGear,
  faHome,
  faList,
  faMobile,
  faMoneyBill,
  faNetworkWired,
  faPencil,
  faPhone,
  faPresentationScreen,
  faQuestion,
  faReceipt,
  faShoppingBag,
  faTag,
  faTruck,
  faUser,
  faVideo,
  faWindow,
  faTriangleExclamation,
  faRotate,
  faAlarmClock
} from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown, faChevronUp, faSearch } from '@fortawesome/pro-solid-svg-icons';
import dayjs from 'dayjs';
import { useDYAPartnerAllowedFunctionApi } from '~/modules/nuxt3-module-admin-doyac/composables/dya-admin-partner-allowed-function';
import { useDYAdminMainStore } from '~/modules/nuxt3-module-admin-doyac/stores/main';
import { useDYAuth } from "~/modules/nuxt3-module-doyac/composables/auth";
import { useDYAppConfig } from "~/modules/nuxt3-module-doyac/composables/config";
import type DYSiteSetting from '~~/modules/nuxt3-module-doyac/composables/dy-site-settings';
import { useDYSiteSettingApi } from '~~/modules/nuxt3-module-doyac/composables/dy-site-settings';

library.add(faChevronDown, faChevronUp, faSearch, faCog,
  faEnvelope,
  faTag,
  faUser,
  faVideo,
  faShoppingBag,
  faClipboardCheck,
  faWindow,
  faChartArea,
  faChartLineUp,
  faFileMusic,
  faTruck,
  faFileWord,
  faPresentationScreen,
  faPencil,
  faBook, faFileCertificate,
  faEye, faNetworkWired, faEyeSlash, faDownload, faMobile, faCards,
  faHome,
  faList,
  faQuestion,
  faTriangleExclamation,
  faRotate,
  faAlarmClock
) // faChevronDown, faChevronUp은 드롭다운이 기본적으로 사용함

const { siteName, fullDomain, dbDomain, shortHostName } = useDYAppConfig()
const { getByKey } = useDYSiteSettingApi()
const adminMainStore = useDYAdminMainStore()
const { isEngineer, isAdmin, isTeacher, isPartner } = useDYAuth()
const siteSettings = ref<DYSiteSetting | null>()

const creatorNameKo = computed(() => {
  if (siteSettings.value) {
    return siteSettings.value?.settingValue
  }
})

const userStore = $dy__useIGUserStore()

onMounted(async () => {
  siteSettings.value = await getByKey('creator_name_ko')

  //default페이지에서는 유저스토어의 ready가 없으면 제대로 auth를 알아내지 못함(체크하는데 시간이 필요해서)
  await userStore.ready()

  setTimeout(async () => {
    if (isTeacher.value || isPartner.value) {
      adminMainStore.menu = [
        {
          id: 'main',
          title: '메인',
          to: '/',
          icon: faHome
        },
      ]

      adminMainStore.addMenu('main', {
        id: 'question-talk',
        title: `문의하기`,
        href: `https://${shortHostName}.channel.io/home`,
        icon: faQuestion,
        target: '_blank'
      })
    }

    if (isTeacher.value) {
      if (!userStore.isCommissionZero) {
        adminMainStore.addMenu('main',
          {
            id: 'monthly-sales-tax',
            title: '매출',
            icon: faReceipt,
            to: '/sales/withHoldingTax'
          }
        )
      }

      adminMainStore.addMenu('main',
        {
          id: 'no-reply-lists',
          title: '미답변 질문',
          icon: faList,
          to: `/teacher/question`,
        },
      )
      adminMainStore.addMenu('main',
        {
          id: 'teacher-management-attendance',
          title: '선생님 촬영 출결내역',
          to: '/teacher/attendance',
          icon: faList
        },
      )
      adminMainStore.addMenu('main',
        {
          id: 'teacher-management-notice',
          title: '선생님 공지사항',
          to: '/teacher/notice',
          icon: faList
        },
      )
    } else if (isPartner.value) {
      if (userStore.availPartnerAllowedFunction('CourseSalesStatistics')) {
        adminMainStore.addMenu('main', {
          id: 'total-sales',
          title: '매출',
          icon: faReceipt,
          to: '/sales/totalSales'
        })
      }
      if (userStore.availPartnerAllowedFunction('CouponIssueList')) {
        adminMainStore.addMenu('main', {
          id: 'coupon-list',
          title: '쿠폰 내역',
          icon: faReceipt,
          to: '/coupon/issued'
        })
      }
      if (userStore.availPartnerAllowedFunction('CoursePayList')) {
        adminMainStore.addMenu('main', {
          id: 'payments-lists',
          title: '결제 내역',
          icon: faList,
          to: `/payments/courses?_startDay=${dayjs().subtract(3, 'year').format('YYYY-MM-DD')}`,
        })
      }

    } else {
      adminMainStore.addMenu('calendar-management-header', { id: 'contents-management-header', title: '콘텐츠 관리', isHeader: true }, 'prepend')

      adminMainStore.addMenu('contents-management-header', {
        id: 'design-frame-manage',
        title: '디자인 틀 관리',
        icon: faPencil,
        to: '/design/designFrame'
      })

      // 2026-04-20 용어사전 메뉴 추가 (구 /apple_doyac/ajax_contents/event/videoSubtitleDictionary.php 포팅)
      // 콘텐츠 관리 > 디자인 틀 관리 아래에 배치. 닷컴/아트 공용
      adminMainStore.addMenu('design-frame-manage', {
        id: 'video-subtitle-dictionary',
        title: '용어사전',
        icon: faBook,
        to: '/videoSubtitleDictionary'
      })

      adminMainStore.addMenu('event-manager',
        {
          id: 'point-cash-management-header',
          title: '포인트/캐시',
          icon: faMoneyBill,
          children: [
            {
              id: 'point-list',
              title: '포인트 내역',
              icon: faReceipt,
              to: '/events/point'
            }, {
              id: 'cash-list',
              title: '별캐시 내역',
              icon: faReceipt,
              to: '/events/starCash'
            },
          ]
        })

      adminMainStore.addMenu('point-cash-management-header',
        {
          id: 'event-management-header',
          title: '이벤트/쿠폰',
          icon: faMoneyBill,
          children: [
            {
              id: 'coupon-template',
              title: '쿠폰 템플릿 등록',
              icon: faReceipt,
              to: '/coupon/template'
            },
            {
              id: 'coupon-list',
              title: '쿠폰 발급 내역',
              icon: faReceipt,
              to: '/coupon/issued'
            },
            {
              id: 'auto-event-for-student',
              title: '상품별 결제자 자동 이벤트',
              icon: faCalendar,
              to: '/engineer/autoEventForStudent'
            },
            {
              id: 'openBell-lists',
              title: '오픈 알리미',
              icon: faPhone,
              to: `/payments/openBellList`
            },
          ]
        })

      adminMainStore.addMenu('coupon-template', {
        id: 'event-list',
        title: '이벤트 내역',
        icon: faPencil,
        to: '/events/list'
      }, 'prepend')
      if (siteName !== '마이퍼스트가이드') { //마퍼가는 필요없음
        adminMainStore.addMenu('coupon-template', {
          id: 'event-auto-register',
          title: '이벤트 자동등록',
          icon: faPencil,
          to: '/events/autoRegister'
        }, 'prepend')
      }

      adminMainStore.addMenu('point-cash-management-header',
        {
          id: 'banner-lists',
          title: '배너관리',
          icon: faCards,
          to: '/banners'
        }, 'prepend')

      adminMainStore.addMenu('log-header', {
        id: 'player-viewer-manage',
        title: '동영상 뷰어',
        icon: faVideo,
        children: [
          {
            id: 'stw-media-connect-log2-list',
            title: '현재 접속자 현황',
            icon: faNetworkWired,
            to: '/media/stw-media-connect-log2s'
          },
          {
            id: 'stw-study-info2-list',
            title: '미디어 접속 로그',
            icon: faEye,
            to: '/media/stw-study-info2s'
          },
          {
            id: 'stw-mobile-download-list',
            title: '다운로드 내역',
            icon: faDownload,
            to: '/media/stw-mobile-downloads'
          },
          {
            id: 'stw-mobile-device-list',
            title: '다운로드 디바이스',
            icon: faMobile,
            to: '/media/stw-mobile-devices'
          },
          {
            id: 'stw-concurrent-connect-record-list',
            title: '동시 접속 차단 내역',
            icon: faEyeSlash,
            to: '/media/stw-concurrent-connect-records'
          },
          {
            id: 'viewer-error-record-list',
            title: '뷰어 오류 내역',
            icon: faTriangleExclamation,
            to: '/media/viewer-error-records'
          },
          {
            id: 'stw-device-reset-history-list',
            title: '기기초기화 내역',
            icon: faRotate,
            to: '/media/stw-device-reset-histories'
          },
          {
            // 2026-04-07: 레거시 PHP 페이지에서 신 관리자 페이지로 전환
            id: 'movie-file-error-log-list',
            title: '동영상 파일 에러기록',
            icon: faTriangleExclamation,
            to: '/media/movie-file-error-logs'
          }
        ],
      })

      if (siteName === "도약닷컴" || siteName === "도약아트") {
        adminMainStore.addMenu(
          'manual-pay-list',
          { id: 'course-payment-list', title: '강의', to: '/payments/courses?_startDay=' + dayjs().subtract(3, 'year').format('YYYY-MM-DD'), icon: faPresentationScreen },
          'prepend'
        )
        adminMainStore.addMenu(
          'manual-pay-list',
          { id: 'book-payment-list', title: '북스토어', to: `/payments/books?_startDay=${dayjs().subtract(3, 'year').format('YYYY-MM-DD')}&__status=2&__status=3&chk_daepyo=1&groupBy=orderNo`, icon: faBook },
          'prepend'
        )
        adminMainStore.addMenu(
          'manual-pay-list',
          { id: 'license-payment-list', title: '자격증', to: '/payments/licenses?_startDay=' + dayjs().subtract(3, 'year').format('YYYY-MM-DD'), icon: faFileCertificate },
          'prepend'
        )

      }
      if (isEngineer.value) {
        adminMainStore.addMenu('site-manager', {
          id: 'group-site',
          title: '개발자 관리',
          icon: faGear,
          children: [
            {
              id: 'server-setting',
              title: '서버점검세팅',
              icon: faGear,
              to: '/siteManage/serverSetting'
            },
            {
              // 260826 구 관리자(apple_doyac/site_manager/serverScheduleManager.php) 이관.
              // 본체 테이블이 doyacinc 단계라 닷컴/아트/마퍼가 관리자 모두에 동일하게 노출된다.
              id: 'server-schedule',
              title: '서버 스케줄 관리',
              icon: faAlarmClock,
              to: '/siteManage/serverSchedule'
            },
            {
              id: 'site_setting-list',
              title: '사이트 설정값',
              icon: faPencil,
              to: '/engineer/siteSetting'
            },
            {
              id: 'black-pcs-list',
              title: '불량번호내역',
              icon: faPencil,
              to: '/users/wrongNumberHistory'
            },
            {
              id: 'black-pcs-users-list',
              title: '불량번호회원',
              icon: faPencil,
              to: '/users/wrongNumber'
            },
            {
              id: 'login-history-manage',
              title: '로그인내역',
              icon: faEyeSlash,
              to: '/users/loginHistory'
            },
            {
              id: 'teacher-address-checks',
              title: '선생님 배송 정보',
              icon: faTruck,
              to: '/teacher/address-checks',
            },
            {
              // 2026-04-07: 의심회원 목록 페이지 추가
              id: 'suspicious-users',
              title: '의심회원',
              icon: faPencil,
              to: '/users/suspicious',
            },
            {
              id: 'log-viewer-manage',
              title: '로그 확인',
              icon: faVideo,
              children: [
                {
                  id: 'doyacinc-log-list',
                  title: '도약INC',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=doyacinc'
                },
                {
                  id: 'doyacweb-log-list',
                  title: '도약닷컴',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=doyacweb'
                },
                {
                  id: 'doyacart-log-list',
                  title: '도약아트',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=doyacart'
                },
                {
                  id: 'myfirstguide-log-list',
                  title: '마이퍼스트가이드',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=myfirstguide'
                },
                {
                  id: 'lessonall-log-list',
                  title: '레슨올',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=lessonall'
                },
                {
                  id: 'sql-log-list',
                  title: 'SQL 로그',
                  icon: faNetworkWired,
                  to: '/siteManage/mongoLog?db=sql_log'
                }
              ]
            }
          ],
        })
      }
    }
  }, 200)
})

</script>